import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DatepickerComponent} from "./datepicker.component";
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [DatepickerComponent],
  exports: [DatepickerComponent],
  imports: [CommonModule, FormsModule]
})
export class DatepickerModule {}
